'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_GoogleSignInError() {
}
export { $c_Lapp_data_GoogleSignInError as $c_Lapp_data_GoogleSignInError };
$p = $c_Lapp_data_GoogleSignInError.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_GoogleSignInError;
/** @constructor */
function $h_Lapp_data_GoogleSignInError() {
}
export { $h_Lapp_data_GoogleSignInError as $h_Lapp_data_GoogleSignInError };
$h_Lapp_data_GoogleSignInError.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
//# sourceMappingURL=app.data.-Google-Sign-In-Error.js.map
